import { get, remove } from '@api';
import { Store } from 'react-notifications-component';
import {
  CONTENT_API_ERRORS_LIMIT,
} from '../../constants/journal-content-api-errors.constants';
import {
  COMMON_DATA_UPDATE_FAIL,
  COMMON_DATA_UPDATE_SUCCESS,
} from '../../constants/notification-settings';

export const FETCH_JOURNAL_CONTENT_API_ERRORS_START = 'FETCH_JOURNAL_CONTENT_API_ERRORS_START';
export const FETCH_JOURNAL_CONTENT_API_ERRORS_SUCCESS = 'FETCH_JOURNAL_CONTENT_API_ERRORS_SUCCESS';
export const FETCH_JOURNAL_CONTENT_API_ERRORS_FAIL = 'FETCH_JOURNAL_CONTENT_API_ERRORS_FAIL';

export const FETCH_JOURNAL_CONTENT_API_ERROR_DETAIL_START = 'FETCH_JOURNAL_CONTENT_API_ERROR_DETAIL_START';
export const FETCH_JOURNAL_CONTENT_API_ERROR_DETAIL_SUCCESS = 'FETCH_JOURNAL_CONTENT_API_ERROR_DETAIL_SUCCESS';
export const FETCH_JOURNAL_CONTENT_API_ERROR_DETAIL_FAIL = 'FETCH_JOURNAL_CONTENT_API_ERROR_DETAIL_FAIL';
export const CLEAR_JOURNAL_CONTENT_API_ERROR_DETAIL = 'CLEAR_JOURNAL_CONTENT_API_ERROR_DETAIL';

const fetchJournalContentApiErrorsStart = () => ({
  type: FETCH_JOURNAL_CONTENT_API_ERRORS_START,
});

const fetchJournalContentApiErrorsSuccess = (payload) => ({
  type: FETCH_JOURNAL_CONTENT_API_ERRORS_SUCCESS,
  payload,
});

const fetchJournalContentApiErrorsFail = (error) => ({
  type: FETCH_JOURNAL_CONTENT_API_ERRORS_FAIL,
  payload: error,
});

const fetchJournalContentApiErrorDetailStart = () => ({
  type: FETCH_JOURNAL_CONTENT_API_ERROR_DETAIL_START,
});

const fetchJournalContentApiErrorDetailSuccess = (payload) => ({
  type: FETCH_JOURNAL_CONTENT_API_ERROR_DETAIL_SUCCESS,
  payload,
});

const fetchJournalContentApiErrorDetailFail = (error) => ({
  type: FETCH_JOURNAL_CONTENT_API_ERROR_DETAIL_FAIL,
  payload: error,
});

export const clearJournalContentApiErrorDetail = () => ({
  type: CLEAR_JOURNAL_CONTENT_API_ERROR_DETAIL,
});

/**
 * Сериализация query-параметров фильтра в строку URL.
 * Никогда не отдаём пустые/undefined значения: backend применяет дефолты
 * (last 24h, limit=30) только если параметр вообще отсутствует.
 */
const paramsToSearch = ({
  page,
  from,
  to,
  statusCodes,
  path,
}) => {
  const offset = (page || 1) * CONTENT_API_ERRORS_LIMIT - CONTENT_API_ERRORS_LIMIT;

  const qp = new URLSearchParams();
  qp.set('limit', CONTENT_API_ERRORS_LIMIT);
  qp.set('offset', offset);

  if (from) {
    qp.set('from', from);
  }
  if (to) {
    qp.set('to', to);
  }
  if (statusCodes) {
    qp.set('statusCodes', statusCodes);
  }
  if (path) {
    qp.set('path', path);
  }

  const searchArr = [];
  qp.forEach((value, key) => {
    searchArr.push(`${key}=${value}`);
  });

  return searchArr.join('&');
};

/**
 * Загрузка страницы журнала ошибок Content API.
 * Поддерживает 1-based page + клиентский limit (через offset).
 */
export const fetchJournalContentApiErrors = (params) => async (dispatch) => {
  dispatch(fetchJournalContentApiErrorsStart());
  try {
    const search = paramsToSearch(params);
    const response = await get(`/journal/content-api-errors?${search}`);
    dispatch(fetchJournalContentApiErrorsSuccess({
      data: response.data,
      params,
    }));
  } catch (e) {
    console.error('fetchJournalContentApiErrors error:', e);
    dispatch(fetchJournalContentApiErrorsFail(e));
  }
};

/**
 * Загрузка полной карточки ошибки по id (для модалки деталей).
 * Не складывается в общий items-стейт — отдельная ветка `detail`.
 */
export const fetchJournalContentApiErrorDetail = (id) => async (dispatch) => {
  dispatch(fetchJournalContentApiErrorDetailStart());
  try {
    const response = await get(`/journal/content-api-errors/${id}`);
    dispatch(fetchJournalContentApiErrorDetailSuccess(response.data));
  } catch (e) {
    console.error('fetchJournalContentApiErrorDetail error:', e);
    dispatch(fetchJournalContentApiErrorDetailFail(e));
  }
};

/**
 * Очистка всего журнала ошибок Content API (mass-delete).
 * Backend удаляет ВСЕ записи (без фильтров), затем мы дёргаем refetch
 * чтобы пользователь увидел пустую таблицу сразу.
 */
export const clearAllJournalContentApiErrors = (refetch, translations) => async () => {
  try {
    await remove('/journal/content-api-errors');
    if (refetch) {
      refetch();
    }
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
  } catch (e) {
    console.error('clearAllJournalContentApiErrors error:', e);
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
  }
};
